{
  "version": 1,
  "asset_id": "0092ef09-3f44-4c3b-ac5c-fb9632b09d72",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/0092ef09-3f44-4c3b-ac5c-fb9632b09d72/electrical-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/0092ef09-3f44-4c3b-ac5c-fb9632b09d72/electrical-hero.webp",
  "original_filename": "electrical-hero.webp",
  "size": 139622,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:09Z"
}
